export { Explore as Icon } from '@mui/icons-material';
export const id = 'karte';
export const label = `${id}:label`;
export const route = '/karte';
